import { TimeZoneService } from './timezone.service';
import { LeadToAccountConvertCustomAttributes } from './../../../leads-v2/model/lead-to-account-convert.model';
import { Injectable } from "@angular/core";

// Constants
import { CUSTOMFIELD_TYPE_IDS } from "../constants/typeId";
import { toFixedDown } from "../helpers/number-value-fixed-down.helper";

@Injectable({ providedIn: 'root' })

export class CustomAttributeService {
    customFieldIds = CUSTOMFIELD_TYPE_IDS;

    constructor(private timezoneService: TimeZoneService){}

    changeCustomCheckbox(event, field, j, optName) {
        const { checked } = event;

        if (checked) {
            const data = field?.customAttribute?.pickListValues[j];
            field.value.push(data);
        } else {
            const index = field.value.findIndex(el => (el === optName || el.name === optName));

            if (index > -1) {
                field.value.splice(index, 1);
            }
        }
    }

    generateCustomFieldValues(moduleName: string, type: string, customAttributeValues, sectionCustomFields) {
        let customFields = [];
        let customValues = [];
        customAttributeValues = customAttributeValues?.length>0 ? customAttributeValues.filter(field=> field.statusId==1) : [];

        customAttributeValues.map(el=>{
            const foundField = sectionCustomFields.find(field => field.name === el.customAttribute?.fieldName && field.formControl.id===el.customAttribute?.formControlId);

            if (foundField) {
                customValues.push(el);
            }
        })

        sectionCustomFields.map(field=>{
            const foundSelectedField = customValues.find(el => el.customAttributeId === field.customAttributeId);

            if (foundSelectedField) {
                if ([this.customFieldIds.DROPDOWN, this.customFieldIds.MULTISELECT, this.customFieldIds.CHECKBOX, this.customFieldIds.FILE,
                this.customFieldIds.PICTURE].includes(foundSelectedField.customAttribute.formControlId)) {
                    let dataValue = foundSelectedField.value;
                    dataValue = ((typeof dataValue === 'string') && dataValue.length) ? JSON.parse(dataValue) : dataValue;

                    if (this.customFieldIds.MULTISELECT === foundSelectedField.customAttribute.formControlId) {
                        try {
                            dataValue = dataValue ? dataValue?.filter(el => el.name)||[] : [];
                        } catch (e) {
                            dataValue = [];
                        }
                    }

                    foundSelectedField.value = dataValue;
                }

                if (this.customFieldIds.DATE_PICKER === foundSelectedField.customAttribute.formControlId) {
                    foundSelectedField.value = foundSelectedField.value ? new Date(foundSelectedField.value) : '';
                }

                if (this.customFieldIds.DATETIMEPICKER === foundSelectedField.customAttribute.formControlId) {
                    foundSelectedField.formattedValue = foundSelectedField.value ? this.timezoneService.formateToUserDate(foundSelectedField.value,'MM/DD/YYYY | h:mm a',false) : '';
                    foundSelectedField.value = foundSelectedField.value ? this.timezoneService.showDateTimeWithZone(foundSelectedField.value,false) : '';
                }

                if ([this.customFieldIds.NUMBER,this.customFieldIds.DECIMAL, this.customFieldIds.CURRENCY].includes(foundSelectedField.customAttribute.formControlId)) {
                    foundSelectedField.value = foundSelectedField.value=="" ? null : foundSelectedField.value;
                }

                if ([this.customFieldIds.USERLOOKUP].includes(foundSelectedField.customAttribute.formControlId)) {
                    foundSelectedField.value = foundSelectedField?.value ? Number(foundSelectedField.value) : null;
                }
            }

            let pickListValues: any = field.formControl.pickListValues || [];

            if (this.customFieldIds.CHECKBOX === field.formControl?.id) {
                if (foundSelectedField && !foundSelectedField.value) {
                    foundSelectedField.value = [];
                }

                pickListValues = pickListValues?.map(value => {
                    const found = foundSelectedField?.value?.find(dt => dt === value);
                    return {
                        name: value,
                        checked: found ? true : false
                    };
                });
            } else {
                pickListValues = field.formControl?.pickListValues.map(el => {
                    return { name: el }
                });
            }

            const customField = {
                id: foundSelectedField?.id || 0,
                name: field.name,
                labelName: field.labelName,
                currencySymbol: field.currencySymbol || null,
                enabledInForm: field.enabledInForm,
                customAttribute: {
                    id: field.customAttributeId,
                    isRequired: field.isRequired,
                    displayLength: field?.displayLength,
                    section: {
                        name: `${moduleName} ${type}`
                    },
                    formControl: {
                        id: field.formControl?.id,
                        name: field.formControl?.type,
                        maxLengthAfterDecimal: field.formControl?.maxLengthAfterDecimal||null,
                        expression: field.formControl?.expression||null,
                    },
                    pickListValues
                },
                value: field?.formControl?.id === this.customFieldIds.CHECKBOX ? (foundSelectedField?.value || []) :
                    foundSelectedField?.value,
                userLookupValue: foundSelectedField?.userLookupValue||"",
                formattedValue: foundSelectedField?.formattedValue||"",
                customeAttachement:  [this.customFieldIds.PICTURE,this.customFieldIds.FILE].includes(field?.formControl?.id) ? foundSelectedField?.value || [] : []
            };

            if (field?.formControl?.id === this.customFieldIds.TOOGLE_BUTTON) {
                customField.value = foundSelectedField?.value?.toLowerCase()=='true' ? true : false;
            }

            customFields.push(customField);
        })

        return { customFields, customValues };
    }

    setSectionCustomPayload(selectedData, customFields, moduleId) {
        let payload = [];

        for (const field of customFields) {
            const { id, name, labelName, customAttribute: { id: customAttributeId, isRequired, section, displayLength }, customeAttachement, value,
                toggle } = field;

            const formControlId = field.customAttribute?.formControl?.id;
            let pickListValues = field.customAttribute?.pickListValues || [];
            pickListValues = pickListValues.map(el => el.name) || [];
            pickListValues = JSON.stringify(pickListValues);

            const data: any = {
                id,
                objectId: moduleId,
                objectValue: selectedData?.id || 0,
                customAttributeId,
                customAttribute: {
                    id: customAttributeId,
                    name,
                    labelname: labelName,
                    displayLength: displayLength,
                    formControl: {
                        id: formControlId,
                        name: field.customAttribute?.formControl?.name || '',
                        maxLengthAfterDecimal: field.customAttribute.formControl?.maxLengthAfterDecimal||null
                    },
                    formControlId,
                    objectId: 2,
                    isRequired,
                    section,
                    statusId: 1,
                    pickListValues
                },
                customeAttachement,
                statusId: 1,
                value: value,
                values: null
            };

            if (formControlId === this.customFieldIds.CHECKBOX) {
                data.multipleCheckBox = data.value?.filter(el => el || el?.name)?.map(el => {
                    if (typeof el === 'string') {
                        return el;
                    } else {
                        return el?.name;
                    }
                }) || [];

                data.value = "";
                data.toggle = false;
                data.values = data.multipleValues = data.customeAttachement = null;
                data.ratingId = 0;

            } else if (formControlId === this.customFieldIds.TOOGLE_BUTTON) {
                data.toggle = toggle || data.value || false;
                data.value = "";
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;
            } else if (formControlId === this.customFieldIds.DATE_PICKER) {
                data.value = data.value ? this.timezoneService._getCustomDateString(data.value) : '';

                data.toggle = false;
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;

            } else if (formControlId === this.customFieldIds.DATETIMEPICKER) {
                data.value = data.value ? this.timezoneService._getCustomDateTimeString(data.value) : '';

                data.toggle = false;
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;

            } else if (formControlId === this.customFieldIds.DROPDOWN) {
                data.values = data.value;

                data.value = "";
                data.toggle = false;
                data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;

            } else if (formControlId === this.customFieldIds.MULTISELECT) {
                data.value = data.value?.length ? data.value : [];

                data.multipleValues = data.value?.map(el => {
                    return { name: el.name }
                }) || [];

                data.value = "";
                data.ratingId = 0;
                data.toggle = false;
                data.values = data.multipleCheckBox = data.customeAttachement = null;

            } else if (formControlId === this.customFieldIds.RATING) {
                data.ratingId = (typeof (data.value) === 'string') ? +data.value : data.value;
                data.ratingId = data.ratingId||0;
                data.value = "";
                data.toggle = false;
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;

            } else if (formControlId === this.customFieldIds.FILE || formControlId === this.customFieldIds.PICTURE) {
                data.customeAttachement = data.customeAttachement||[];
                data.toggle = false;
                data.values = data.multipleValues = data.multipleCheckBox = null;
                data.ratingId = 0;
                data.value = "";

            } else if ([this.customFieldIds.INPUT,this.customFieldIds.MULTI_LINE,
                    this.customFieldIds.EMAIL,this.customFieldIds.PHONE,
                    this.customFieldIds.URL,this.customFieldIds.ENCRYPTEDTEXT,
                    this.customFieldIds.RICHTEXT,this.customFieldIds.BARCODE,
                ].includes(formControlId)) {
                data.value = data.value || "";
                data.toggle = false;
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;

            } else if ([this.customFieldIds.NUMBER,this.customFieldIds.DECIMAL,this.customFieldIds.PERCENTAGE].includes(formControlId)) {
                data.value = (!data.value && data.value!==0) ? "" : toFixedDown(data.value,(data.customAttribute.formControl?.maxLengthAfterDecimal||null));
                data.toggle = false;
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;
                data.currencySymbol = field.currencySymbol || null;

            } else if (formControlId === this.customFieldIds.RADIO_BUTTON) {
                data.toggle = false;
                data.value = data.value || "";
                data.values = data.multipleValues = data.multipleCheckBox = data.customeAttachement = null;
                data.ratingId = 0;
            }

            payload.push(data);
        }

        return payload || [];
    }

    setLeadConvertCustomPayload(customFields) {
        let payload: LeadToAccountConvertCustomAttributes[] = [];

        for (const field of customFields) {
            const { id, name, labelName, customAttribute: { id: customAttributeId, isRequired, section }, customeAttachement, value,
                toggle } = field;

            const formControlId = field.customAttribute?.formControl?.id;
            let pickListValues = field.customAttribute?.pickListValues || [];
            pickListValues = pickListValues.map(el => el.name) || [];
            pickListValues = JSON.stringify(pickListValues);

            const data: LeadToAccountConvertCustomAttributes = {
                id: customAttributeId,
                values: [],
                attachments: []
            };

            if (formControlId === this.customFieldIds.CHECKBOX) {
                data.values = value?.filter(el => el || el?.name)?.map(el => {
                    if (typeof el === 'string') {
                        return el;
                    } else {
                        return el?.name;
                    }
                }) || [];
            } else if (formControlId === this.customFieldIds.TOOGLE_BUTTON) {
                const toggleValue = toggle || value || false;
                data.values = [toggleValue?.toString()]
            } else if (formControlId === this.customFieldIds.DATE_PICKER) {
                const dateValue = value ? this.timezoneService._getCustomDateString(value) : '';
                data.values = dateValue ? [dateValue] : [];
            } else if (formControlId === this.customFieldIds.DATETIMEPICKER) {
                const dateValue: any = value ? this.timezoneService._getCustomDateTimeString(value) : '';
                data.values = dateValue ? [dateValue] : [];
            } else if (formControlId === this.customFieldIds.DROPDOWN) {
                data.values = value?.name ? [value?.name] : [];
            } else if (formControlId === this.customFieldIds.MULTISELECT) {
                data.values = value?.map(el => {
                    if(el?.name) return el.name
                }) || [];

            } else if (formControlId === this.customFieldIds.RATING) {
                const ratingValue = (typeof (value) === 'string') ? value : value?.toString();
                data.values = ratingValue ? [ratingValue] : [];
            } else if (formControlId === this.customFieldIds.FILE || formControlId === this.customFieldIds.PICTURE) {
                data.attachments = customeAttachement||[];
                data.values = [];
            } else if (formControlId === this.customFieldIds.INPUT) {
                data.values = value ? [value] : [];
            } else if (formControlId === this.customFieldIds.NUMBER || formControlId === this.customFieldIds.DECIMAL) {
                data.values = (!value && value!==0) ? [] : [value.toString()];
            } else if (formControlId === this.customFieldIds.RADIO_BUTTON) {
                data.values = value ? [value] : [];
            } else {
                data.values = (value || value===0) ? [value] : [];
            }

            if(data?.values?.length>0 || data?.attachments?.length>0){
                payload.push(data);
            }
        }

        return payload || [];
    }
}
